module.exports = __webpack_public_path__ + "static/mstile-144x144-9bd5e87030cf9993875fd79ab0b2b72a.png";